let myHeaders = new Headers();
myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

let allChart = document.querySelectorAll('.mioChart')

function chartReload() {
    UIkit.util.on('.mioChart', 'inview', function (element) {
        api(element.target);
    });
}
chartReload();
document.addEventListener('swup:contentReplaced', chartReload);
function api(element) {

    let data = new FormData();
    data.append('uuid', element.dataset.uuid);

    let postData = Array.from(
        data,
        e => e.map(encodeURIComponent).join('=')
    ).join('&');

    let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: postData,
        redirect: 'follow'
    };


    fetch('/index.php?rex-api-call=execute_chart', requestOptions)
        .then(response => response.json())
        .then(data => {

            /*Animation*/
            const totalDuration = 4000;
            const delayBetweenPoints = totalDuration / data.data.length;
            const previousY = (ctx) => ctx.index === 0 ? ctx.chart.scales.y.getPixelForValue(100) : ctx.chart.getDatasetMeta(ctx.datasetIndex).data[ctx.index - 1].getProps(['y'], true).y;
            const animation = {
                x: {
                    type: 'number',
                    easing: 'linear',
                    duration: delayBetweenPoints,
                    from: NaN, // the point is initially skipped
                    delay(ctx) {
                        if (ctx.type !== 'data' || ctx.xStarted) {
                            return 0;
                        }
                        ctx.xStarted = true;
                        return ctx.index * delayBetweenPoints;
                    }
                },
                y: {
                    type: 'number',
                    easing: 'linear',
                    duration: delayBetweenPoints,
                    from: previousY,
                    delay(ctx) {
                        if (ctx.type !== 'data' || ctx.yStarted) {
                            return 0;
                        }
                        ctx.yStarted = true;
                        return ctx.index * delayBetweenPoints;
                    }
                }
            };

            /*CHART - Start*/
            const ctx = element.getContext("2d");

            const myChart = new Chart(ctx, {
                type: data.chart,
                data: {
                    labels: data.year,
                    datasets: [{
                        label: "Daten",
                        backgroundColor: data.color,
                        borderColor: data.color,
                        borderWidth: 3,
                        pointRadius: 5,
                        fill: false,
                        data: data.data
                    }]
                },
                options: {
                    animation,
                    interaction: {
                        intersect: false
                    },
                    plugins: {
                        legend: false
                    },
                    responsive: true,
                    legend: {
                        position: "bottom"
                    },
                },
            });
        })
}

/*CHART - End*/
